import React, {Component} from 'react'
import StyleSheet from 'styles'
import PropTypes from 'prop-types'
import Lock from './Lock'
import {Markdown} from 'components/Markdown'
import Downloads from './Downloads'
import {FormattedMessage} from 'react-intl'

const ipsum = "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."

export class InvestorInfo extends Component {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  get locked() { return this.props.dealSheet.locked }
  get isProduct() { return this.props.dealSheet.typeOfIssuance === 'product' }
  get description() { return this.locked ? ipsum : this.props.dealSheet.description }
  get issuanceInfo() { return this.locked ? ipsum : (this.isProduct ? this.props.dealSheet.problemBeingSolved : this.props.dealSheet.description) }
  get risks() { return this.locked ? ipsum : this.props.dealSheet.risks }

  render = () =>
    <div className={this.props.className}>
      <div className={styles.container}>
        { this.isProduct &&
          <div className={styles.wideCell}>
            <div className={styles.detail}>
              <Markdown mdtext={this.description} />
            </div>
          </div>
        }
        {this.props.dealSheet.typeOfIssuance !== 'product' && (
          <div className={styles('flexContainer', {hidden: this.props.dealSheet.locked})}>
            <div className={styles.flexCell}>
              <h3 className={styles.heading}><FormattedMessage id="deal.investor_info.issuance_info_label" /></h3>
              <div className={styles.detail}>
                <Markdown mdtext={this.issuanceInfo}/>
              </div>
            </div>
            <div className={styles.flexCell}>
              <h3 className={styles.heading}>Risks</h3>
              <div className={styles.detail}>
                <Markdown mdtext={this.risks}/>
              </div>
            </div>
          </div>
        )}
        {!this.locked || <Lock/>}
      </div>
      <Downloads dealSheet={this.props.dealSheet}/>
    </div>
}

const styles = StyleSheet({
  container: {
    position: 'relative'
  },
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  flexCell: {
    flex: '1',
    minWidth: 400,
    maxWidth: '50%',
    paddingRight: 75,
    boxSizing: 'border-box',
    marginBottom: 50,
    '@media(max-width: 875px)': {
      maxWidth: '100%',
    },
    '@media(max-width: 600px)': {
      paddingRight: 0,
      minWidth: 301,
    }
  },
  wideCell: {
    marginBottom: 50,
  },
  heading: {
    fontSize: '16px',
    paddingBottom: 15,
    fontWeight: 'bold',
    margin: 0,
  },
  detail: {
    fontSize: '13px',
    lineHeight: '20px',
    '& p': {
      marginTop: 0,
    }
  },
  hidden: {
    filter: 'blur(5px)'
  },
})

export default InvestorInfo